import {
    HttpClient,
    HttpErrorResponse,
    HttpHeaders,
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { BehaviorSubject, Observable, tap } from 'rxjs'
import { RequestService } from '../request/request.service'
import { QueryGet } from '../../shared/query-types'
import { Pagination } from '../../models/pagination.interface'
import { Education, EducationDTO } from '../../models/education.interface'
import { AsyncFormValidation } from '../../interceptors/error.interceptor'

@Injectable({
    providedIn: 'root',
})
export class EducationService {
    httpOptions = {
        headers: new HttpHeaders({}),
    }
    private apiUrl = environment.service_1 + 'education/'
    private educations = new BehaviorSubject<Education[]>([])
    educations$ = this.educations.asObservable()

    private educationsSelected = new BehaviorSubject<Education | null>(null)
    $educationsSelected = this.educationsSelected.asObservable()

    private asyncErrorValidation =
        new BehaviorSubject<AsyncFormValidation | null>(null)
    asyncErrorValidation$ = this.asyncErrorValidation.asObservable()

    constructor(
        private requestService: RequestService,
        private http: HttpClient
    ) {}

    setEducations(educations: Education[]) {
        this.educations.next(educations)
    }
    setEducation(education: Education) {
        this.educationsSelected.next(education)
    }

    allEducation(): Observable<Education[]> {
        return this.http.get<Education[]>(this.apiUrl, {
            headers: this.httpOptions.headers,
        })
    }

    allEducations(queryParams: QueryGet): Observable<Pagination<Education[]>> {
        return this.requestService.get<Education[]>(this.apiUrl, queryParams)
    }

    deleteEducation(id: number): Observable<void> {
        return this.http.delete<void>(this.apiUrl + id + '/')
    }

    updateEducation(id: number, education: EducationDTO & { id: number }) {
        return this.http.put<Education>(this.apiUrl + id + '/', education).pipe(
            tap({
                error: (err: HttpErrorResponse) => {
                    this.asyncErrorValidation.next(err.error)
                },
            })
        )
    }
}
